module.exports = __webpack_public_path__ + "img/s8-img2.d7d52e41.png";